exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-item{cursor:pointer;padding:14px 16px;transition:background-color .2s ease;display:flex;justify-content:space-between;align-items:center}.store-item:hover{background-color:#f8f8f8}.store-item.selected,.store-item.selected:hover{background-color:#f0f0f0}.badge-container{display:flex;gap:8px;align-items:center}.store-badge{color:#1c3b82}", ""]);

// exports
